<template>
  <div class="reg_box">
    <div class="title">
      <p>终端注册</p>
    </div>
    <div class="form_box">
      <div class="dev_info">
        <div>
          <p>设备状态: {{ formInline.client_sta_nm }}</p>
          <p>设备编号: {{ formInline.client_cd }}</p>
          <!-- <p>设备用途: {{ formInline.client_type }}</p> -->
        </div>
        <div>
          <p>设备标识: {{ formInline.client_dev }}</p>
          <p>设备类型: {{ formInline.client_dev_nm }}</p>
        </div>
        <div>
          <p>代理软件: {{ formInline.client_agent }}</p>
          <p>操作系统: {{ formInline.client_os }}</p>
        </div>
      </div>
      <div style="display: flex;align-items: center;margin-bottom: 0.3rem;font-size: 0.3rem;">
        <label for="username" style="font-size: 0.3rem;width: 2rem;">设备名称：</label>
        <input id="username" v-model="formInline.client_nm" type="text" placeholder="请输入设备名称"
          style="width: 100%;height: 0.6rem;font-size: 0.25rem;padding: 0 0.1rem;box-sizing: border-box;border: 1px solid #ccc;" />
      </div>
      <div style="display: flex;align-items: center;margin-bottom: 0.3rem;font-size: 0.3rem;">
        <label for="hsp_cd" style="font-size: 0.3rem;width: 2rem;">中心编码：</label>
        <input id="hsp_cd" v-model="formInline.fk_hsp_cd" type="text" placeholder="请输入中心编码"
          style="width: 100%;height: 0.6rem;font-size: 0.25rem;padding: 0 0.1rem;box-sizing: border-box;border: 1px solid #ccc;" />
      </div>
      <div style="display: flex;align-items: center;margin-bottom: 0.3rem;font-size: 0.3rem;">
        <label for="inst_pwd" style="font-size: 0.3rem;width: 2rem;">安装密码：</label>
        <input id="inst_pwd" v-model="formInline.inst_pwd" type="text" placeholder="请输入安装密码"
          style="width: 100%;height: 0.6rem;font-size: 0.25rem;padding: 0 0.1rem;box-sizing: border-box;border: 1px solid #ccc;" />
      </div>
      <div style="display: flex;align-items: center;margin-bottom: 0.3rem;font-size: 0.3rem;">
        <label for="client_gate" style="font-size: 0.3rem;width: 2rem;">网关地址：</label>
        <input id="client_gate" v-model="formInline.client_gate" type="text" placeholder="请输入网关地址"
          style="width: 100%;height: 0.6rem;font-size: 0.25rem;padding: 0 0.1rem;box-sizing: border-box;border: 1px solid #ccc;" />
      </div>
      <div style="display: flex;align-items: center;margin-bottom: 0.3rem;font-size: 0.3rem;">
        <label for="client_info" style="font-size: 0.3rem;width: 2rem;">设备备注：</label>
        <input id="client_info" v-model="formInline.client_info" type="text" placeholder="请输入设备备注"
          style="width: 100%;height: 0.6rem;font-size: 0.25rem;padding: 0 0.1rem;box-sizing: border-box;border: 1px solid #ccc;" />
      </div>
      <div class="button_box">
        <button class="button" type="button" @click="YntsClientreg" style="background-color: var(--color-primary);">注册设备</button>
        <button class="button" type="button" @click="toLogin" style="background-color: var(--color-primary);">返回登录</button>
        <button class="button" type="button" @click="toConfig" style="background-color: var(--color-primary);">系统配置</button>
      </div>
    </div>
  </div>
</template>

<script>
import Device from 'current-device'
import { CallPubMsg } from '@/utils/request'

export default {
  name: 'Register',
  data() {
    return {
      // 响应式表单数据（替代Vue3的ref）
      formInline: {
        client_cd: '',
        client_nm: '大屏',
        client_dev: '',
        client_dev_nm: '',
        client_os: '',
        client_agent: '',
        client_info: '',
        client_gate: 'http://172.16.0.83:8580',
        client_enc: '',
        client_sta: 0,
        client_type: 8,
        client_sta_nm: '',
        inst_pwd: '123',
        fk_hsp_cd: '80011',
      },
      // 初始化pinia store实例
      // usrstore: useAuthStore()
    }
  },
  // 替代Vue3的onMounted钩子
  mounted() {
    // 加载设备信息 + 检查注册状态
    this.LoadDevInfo()
    this.YntsCheckReginfo()
  },
  methods: {
    // 返回登录页
    toLogin() {
      this.$store.state.auth.isLoginPages = true;
    },

    // 【YNTS】检查客户端是否注册
    YntsCheckReginfo() {
      console.log('检查客户端注册信息1111：', JSON.stringify(this.$store.state.auth.CLIENT_CONFIG));
      
      const client_cd = this.$store.state.auth.CLIENT_CONFIG.client_cd
      if (client_cd) {
        // 同步store中的配置到表单
        this.formInline.client_agent = this.$store.state.auth.CLIENT_CONFIG.client_agent
        this.formInline.client_cd = this.$store.state.auth.CLIENT_CONFIG.client_cd
        this.formInline.client_dev = this.$store.state.auth.CLIENT_CONFIG.client_dev
        this.formInline.client_dev_nm = this.$store.state.auth.CLIENT_CONFIG.client_dev_nm
        this.formInline.client_gate = this.$store.state.auth.CLIENT_CONFIG.client_gate
        this.formInline.client_info = this.$store.state.auth.CLIENT_CONFIG.client_info
        this.formInline.client_nm = this.$store.state.auth.CLIENT_CONFIG.client_nm
        this.formInline.client_os = this.$store.state.auth.CLIENT_CONFIG.client_os
        this.formInline.client_type = this.$store.state.auth.CLIENT_CONFIG.client_type
        this.formInline.fk_hsp_cd = this.$store.state.auth.CLIENT_CONFIG.client_hsp + ''
        
        // 检查注册状态
        this.YntsCheckClientSta()
      }
    },

    // 【YNTS】检查客户端注册状态
    async YntsCheckClientSta() {
      try {
        const res = await CallPubMsg('/auth/client', {
          system: 'his',
          req: 'CLIENT_STA',
          client_cd: this.$store.state.auth.CLIENT_CONFIG.client_cd
        });
        console.log('检查客户端注册状态结果：', JSON.stringify(res));

        if (res.sta !== 1) {
          this.$myNotify({
            title: '警告',
            message: res.message || '检查客户端注册状态失败！',
            type: 'error'
          })
          return
        }

        if (!res.body.res) {
          this.$myNotify({
            title: '警告',
            message: res.msg || '检查客户端注册状态失败！',
            type: 'error'
          })
          return
        }

        // 更新设备状态显示
        switch (res.body.client.client_sta) {
          case 1:
            this.formInline.client_sta = 1
            this.formInline.client_sta_nm = '已注册';
            break;
          case -9:
            this.formInline.client_sta_nm = '锁定';
            this.$myNotify({ title: '警告', message: '客户端已停用，请联系管理员！', type: 'error' })
            break;
          case 0:
            this.formInline.client_sta_nm = '审核中';
            this.$myNotify({ title: '警告', message: '客户端注册正在审核中！', type: 'error' })
            break;
          default:
            this.formInline.client_sta_nm = '未注册';
            this.$myNotify({ title: '警告', message: '客户端未注册，请先注册客户端！', type: 'error' })
        }
      } catch (err) {
        console.error('检查注册状态异常：', err)
        this.$myNotify({ title: '错误', message: '检查注册状态时发生异常！', type: 'error' })
      }
    },

    // 【YNTS】终端注册
    async YntsClientreg() {
      try {
        // 更新网关配置
        this.$store.commit('auth/SET_CLIENT_GATE',this.formInline.client_gate);
        
        const res = await CallPubMsg('/auth/client', {
          system: 'his',
          req: 'CLIENT',
          client_cd: this.formInline.client_cd,
          client_nm: this.formInline.client_nm,
          client_dev: this.formInline.client_dev,
          client_dev_nm: this.formInline.client_dev_nm,
          client_os: this.formInline.client_os,
          client_info: this.formInline.client_info,
          client_gate: this.formInline.client_gate,
          client_enc: this.formInline.client_enc,
          client_agent: this.formInline.client_agent,
          client_type: this.formInline.client_type,
          inst_pwd: this.formInline.inst_pwd,
          fk_hsp_cd: this.formInline.fk_hsp_cd,
        });

        if (res.sta !== 1) {
          this.$myNotify({
            title: '警告',
            message: res.message || '终端注册失败！',
            type: 'error'
          })
          return
        }

        if (!res.body.res) {
          this.$myNotify({
            title: '警告',
            message: res.msg || '终端注册失败！',
            type: 'error'
          })
          return
        }

        console.log('终端注册结果：', res);
        // 更新表单和store配置
        this.formInline.client_cd = res.body.client_cd
        this.formInline.client_sta_nm = '审核中'
        
        const conf = {
          client_agent: this.formInline.client_agent,
          client_cd: this.formInline.client_cd,
          client_nm: this.formInline.client_nm,
          client_dev: this.formInline.client_dev,
          client_dev_nm: this.formInline.client_dev_nm,
          client_os: this.formInline.client_os,
          client_info: this.formInline.client_info,
          client_gate: this.formInline.client_gate,
          client_enc: this.formInline.client_enc,
          client_type: this.formInline.client_type,
          client_hsp: this.formInline.fk_hsp_cd,
          usr_pwd: '',
          usr_gid: ''
        }
        
        this.$store.commit('auth/SET_CLIENT_CONFIG',conf);
        // postMessageToApp('data', 'cache_data', conf);
        if (this.$isAppEnvironment()) {
          // 发送关闭APP指令
          this.$postMessageToApp('data', 'cache_data', conf);
        } else {
          alert('当前非APP环境');
        }
        
        this.$myNotify({
          title: '',
          message: '终端注册成功，请联系管理员审核！',
          type: 'success'
        })
      } catch (err) {
        console.error('终端注册异常：', err)
        this.$myNotify({ title: '错误', message: '终端注册时发生异常！', type: 'error' })
      }
    },

    // 加载设备信息（从立即执行函数改为方法）
    LoadDevInfo() {
      // 识别设备类型
      if (Device.mobile()) {
        this.formInline.client_dev_nm = '手机'
        this.formInline.client_dev = 'MOB'
      } else if (Device.tablet()) {
        this.formInline.client_dev_nm = '平板'
        this.formInline.client_dev = 'PAD'
      } else if (Device.desktop()) {
        this.formInline.client_dev_nm = '桌面'
        this.formInline.client_dev = 'PC'
      } else if (Device.television()) {
        this.formInline.client_dev_nm = '电视'
        this.formInline.client_dev = 'TV'
      }

      // 识别操作系统
      this.formInline.client_os = Device.os
      
      // 识别浏览器
      const ua = navigator.userAgent;
      if (ua.indexOf("Chrome") > -1 && ua.indexOf("Edge") === -1) {
        this.formInline.client_agent = "Chrome";
      } else if (ua.indexOf("Firefox") > -1) {
        this.formInline.client_agent = "Firefox";
      } else if (ua.indexOf("Safari") > -1 && ua.indexOf("Chrome") === -1) {
        this.formInline.client_agent = "Safari";
      } else if (ua.indexOf("Edge") > -1) {
        this.formInline.client_agent = "Edge";
      } else if (ua.indexOf("Trident") > -1) {
        this.formInline.client_agent = "IE";
      } else {
        this.formInline.client_agent = "<未知>";
      }
    },

    // 跳转系统配置
    toConfig() {
      console.log('跳转系统配置');
      // postMessageToApp('instruct', 'app_toConfig', '');
      if (this.$isAppEnvironment()) {
        // 发送关闭APP指令
        this.$postMessageToApp('instruct', 'app_toConfig', '');
      } else {
        alert('当前非APP环境');
      }
    }
  }
}
</script>

<style scoped>
/* 移除SCSS，改为普通CSS层级写法 */
.reg_box {
  width: 100%;
  height: 100%;
  border-radius: 0.1rem;
  color: #000;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.reg_box .title {
  font-size: 0.5rem;
  font-weight: 800;
  margin-bottom: 0.1rem;
  text-align: center;
}

.reg_box .form_box {
  width: 100%;
  padding: 0 0.2rem;
  box-sizing: border-box;
}

.button_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.button {
  font-size: 0.3rem;
  height: 0.7rem;
  padding: 0 0.2rem;
  color: #fff;
  border: none;
  border-radius: 0.1rem;
  cursor: pointer;
}

.button:active {
  opacity: 0.8;
}

.reg_box .form_box .dev_info {
  display: flex;
  justify-content: space-between;
  font-size: 0.25rem;
  padding: 0.3rem 0;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  margin-bottom: 0.3rem;
}

/* Vue2深度选择器（替换:deep()为/deep/） */
.reg_box .form_box /deep/ .el-form-item {
  margin-bottom: 0.3rem !important;
}

.reg_box .form_box /deep/ .el-radio.el-radio--large .el-radio__label {
  font-size: 0.27rem !important;
}

.reg_box .form_box /deep/ .el-form-item__label {
  margin-right: 0.1rem !important;
}

.reg_box .form_box /deep/ .el-radio.el-radio--large .el-radio__inner {
  width: 0.25rem;
  height: 0.25rem;
}

.reg_box .form_box /deep/ .el-input__inner {
  height: 0.6rem !important;
  font-size: 0.25rem !important;
}

.reg_box .form_box /deep/ .el-form-item--large {
  --font-size: 0.25rem !important;
}

.reg_box .form_box /deep/ .el-form-item__label {
  height: 0.6rem !important;
  line-height: 0.6rem !important;
}
</style>